import React from "react";
import { Button, Card, Col, DatePicker, Input, Row, Select, Space } from "antd";
import { PlusOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

const PricePeriodFilters = ({
    filters,
    vendors,
    statusOptions,
    onChange,
    onSearch,
    onReset,
    onCreate,
}) => {
    return (
        <Card size="small" style={{ marginBottom: 16 }}>
            <Row gutter={[12, 12]} align="middle">
                <Col>
                    <Select
                        placeholder="供应商"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        style={{ width: 220 }}
                        value={filters.vendor_id}
                        onChange={(value) => onChange({ vendor_id: value })}
                    >
                        {vendors.map((vendor) => (
                            <Select.Option key={vendor.id} value={vendor.id}>
                                {vendor.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Input
                        placeholder="机场代码"
                        allowClear
                        style={{ width: 120 }}
                        value={filters.airport_code}
                        onChange={(event) => onChange({ airport_code: event.target.value })}
                    />
                </Col>
                <Col>
                    <Select
                        placeholder="状态"
                        allowClear
                        style={{ width: 130 }}
                        value={filters.status}
                        onChange={(value) => onChange({ status: value })}
                    >
                        {statusOptions.map((option) => (
                            <Select.Option key={option.value} value={option.value}>
                                {option.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <RangePicker
                        placeholder={["周期开始", "周期结束"]}
                        value={filters.dateRange}
                        onChange={(value) => onChange({ dateRange: value })}
                    />
                </Col>
                <Col>
                    <Input
                        placeholder="机场 / 备注关键词"
                        allowClear
                        style={{ width: 220 }}
                        value={filters.search_term}
                        onChange={(event) => onChange({ search_term: event.target.value })}
                    />
                </Col>
                <Col>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined />} onClick={onSearch}>
                            查询
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={onReset}>
                            重置
                        </Button>
                    </Space>
                </Col>
                <Col flex="auto" style={{ textAlign: "right" }}>
                    <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
                        新建价格周期
                    </Button>
                </Col>
            </Row>
        </Card>
    );
};

export default PricePeriodFilters;
